/**
 * @generated SignedSource<<1db22afa5ce2e4b3ff1dbe0ab2af9e00>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Query } from 'relay-runtime';
export type useFilterRecordingsByCompanyIntegrationsQuery$variables = {};
export type useFilterRecordingsByCompanyIntegrationsQuery$data = {
  readonly viewer: {
    readonly account: {
      readonly integrations: {
        readonly hubspot: {
          readonly accountConnected: boolean;
        } | null;
        readonly salesforce: {
          readonly isConnected: boolean;
        } | null;
      };
    };
  };
};
export type useFilterRecordingsByCompanyIntegrationsQuery = {
  response: useFilterRecordingsByCompanyIntegrationsQuery$data;
  variables: useFilterRecordingsByCompanyIntegrationsQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "isConnected",
  "storageKey": null
},
v1 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "accountConnected",
  "storageKey": null
},
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "metadata": null,
    "name": "useFilterRecordingsByCompanyIntegrationsQuery",
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "Viewer",
        "kind": "LinkedField",
        "name": "viewer",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "Account",
            "kind": "LinkedField",
            "name": "account",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": null,
                "concreteType": "AccountIntegrations",
                "kind": "LinkedField",
                "name": "integrations",
                "plural": false,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "SalesforceWorkspaceConfigurationNode",
                    "kind": "LinkedField",
                    "name": "salesforce",
                    "plural": false,
                    "selections": [
                      (v0/*: any*/)
                    ],
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "HubspotAccountNode",
                    "kind": "LinkedField",
                    "name": "hubspot",
                    "plural": false,
                    "selections": [
                      (v1/*: any*/)
                    ],
                    "storageKey": null
                  }
                ],
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [],
    "kind": "Operation",
    "name": "useFilterRecordingsByCompanyIntegrationsQuery",
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "Viewer",
        "kind": "LinkedField",
        "name": "viewer",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "Account",
            "kind": "LinkedField",
            "name": "account",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": null,
                "concreteType": "AccountIntegrations",
                "kind": "LinkedField",
                "name": "integrations",
                "plural": false,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "SalesforceWorkspaceConfigurationNode",
                    "kind": "LinkedField",
                    "name": "salesforce",
                    "plural": false,
                    "selections": [
                      (v0/*: any*/),
                      (v2/*: any*/)
                    ],
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "HubspotAccountNode",
                    "kind": "LinkedField",
                    "name": "hubspot",
                    "plural": false,
                    "selections": [
                      (v1/*: any*/),
                      (v2/*: any*/)
                    ],
                    "storageKey": null
                  }
                ],
                "storageKey": null
              },
              (v2/*: any*/)
            ],
            "storageKey": null
          },
          (v2/*: any*/)
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "ba0f88e753f553dc208a3ff2b0da2935",
    "id": null,
    "metadata": {},
    "name": "useFilterRecordingsByCompanyIntegrationsQuery",
    "operationKind": "query",
    "text": "query useFilterRecordingsByCompanyIntegrationsQuery {\n  viewer {\n    account {\n      integrations {\n        salesforce {\n          isConnected\n          id\n        }\n        hubspot {\n          accountConnected\n          id\n        }\n      }\n      id\n    }\n    id\n  }\n}\n"
  }
};
})();

(node as any).hash = "dd07b0c762303c9d1bdf73729cfd5755";

export default node;
